export default function formatOperationToastHtml(title, body) {
  return `<b>${title}</b><br />${body}`;
}
